export function getBeginDate(beginDate, endDate) {
  if (beginDate.format('YYYY') !== endDate.format('YYYY')) {
    return beginDate.format('Do MMMM YYYY');
  } if (beginDate.format('MMMM') !== endDate.format('MMMM')) {
    return beginDate.format('Do MMMM');
  }
  return beginDate.format('Do');

}